
import React from 'react';
import { ChevronRight, DollarSign } from 'lucide-react';
import { useAppContext } from '../../App';

const ChatListItem = ({ chat, onClick }) => {
    const { user } = useAppContext();

    if (!chat || !chat.participants || !chat.participantDetails) {
        return null;
    }

    const otherParticipantId = chat.participants.find(p => p !== user.uid);
    const otherParticipant = chat.participantDetails[otherParticipantId];

    const displayName = otherParticipant?.companyName || otherParticipant?.name || 'Usuário Desconhecido';

    const formatDate = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) {
            return '';
        }
        return date.toLocaleDateString('pt-BR');
    };

    const statusConfig = {
        'Novo': { color: '#3B82F6' },
        'Orçamento Enviado': { color: '#F59E0B' },
        'Agendamento': { color: '#8B5CF6' },
        'Em Andamento': { color: '#10B981' },
        'Aguardando Pagamento': { color: '#3B82F6', isPriority: true },
        'Finalizado': { color: '#6B7280' },
    };

    const config = statusConfig[chat.status] || { color: '#6B7280' };

    return (
        <div
            onClick={onClick}
            className={`rounded-xl shadow-md overflow-hidden flex items-stretch mb-3 cursor-pointer transition-all duration-300 hover:scale-[1.01] active:scale-[0.98] ${config.isPriority ? 'bg-blue-50/30 ring-2 ring-blue-100' : 'bg-white'}`}
        >
            <div style={{ backgroundColor: config.color }} className="w-2 flex-shrink-0"></div>
            <div className="flex-grow flex items-center justify-between p-4 min-w-0">
                <div className="flex items-center min-w-0">
                    <div className="w-12 h-12 rounded-xl overflow-hidden bg-white border border-gray-100 shadow-sm flex items-center justify-center p-0.5 mr-4 flex-shrink-0">
                        <img
                            src={otherParticipant?.photoUrl || `https://ui-avatars.com/api/?name=${displayName.replace(/ /g, '+') || 'U'}`}
                            alt={displayName}
                            className="w-full h-full object-contain rounded-lg"
                        />
                    </div>

                    <div className="min-w-0">
                        <h3 className="font-bold text-gray-800 text-lg truncate leading-none">{displayName}</h3>

                        {/* EVIDÊNCIA DE PAGAMENTO PENDENTE */}
                        {chat.status === 'Aguardando Pagamento' ? (
                            <div className="flex items-center text-blue-600 font-black text-[9px] uppercase tracking-widest mt-1.5 animate-pulse">
                                <DollarSign size={12} className="mr-1" /> Pagamento Pendente
                            </div>
                        ) : (
                            <p className="text-sm text-gray-600 truncate mt-1">{chat.serviceTitle || 'Conversa'}</p>
                        )}

                        <p className="text-xs text-gray-400 mt-1 truncate italic">"{chat.lastMessage}"</p>
                    </div>
                </div>
                <div className="flex flex-col items-end ml-4 flex-shrink-0">
                    <span className="text-[10px] text-gray-400 font-bold mb-2 uppercase">{formatDate(chat.lastMessageTimestamp)}</span>
                    <ChevronRight className="w-5 h-5 text-gray-300" />
                </div>
            </div>
        </div>
    );
};

export default ChatListItem;
